<template>
  <!--translate-->
  <div>
    <v-tooltip bottom v-if="!isReadOnlyUser">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="editItem(item)"
          data-cy="edit"
        >
          edit</v-icon
        >
      </template>
      <span>{{ $t("employeeGroup.editGroup") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canDeleteHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openDeleteDialog(item)"
          data-cy="delete"
        >
          delete</v-icon
        >
      </template>
      <span>{{ $t("employeeGroup.deleteTitle") }}</span>
    </v-tooltip>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
  </div>
</template>

<script>
import deleteDialog from "../../_utils/dataTableHelpers/actions/deleteDialog.vue";
export default {
  props: ["item"],
  components: {
    deleteDialog,
  },
  data: () => ({
    deleteDialog: {
      open: false,
      title: "employeeGroup.deleteTitle",
      description: "",
    },
  }),
  methods: {
    editItem(item) {
      this.$router.push({
        name: "employeeGroupForm",
        params: { id: item.id, mode: "edit" },
      });
    },
    openDeleteDialog(item) {
      this.deleteDialog.open = true;
      /*this.deleteDialog.description = this.$t(
        "employeeGroups.deleteTitleLong",
        {
          title: item.name,
        }
      );*/
      this.deleteDialog.description =
        this.$t("employeeGroup.deleteConfirm", { name: item.name });
    },
    deleteItem(item) {
      this.$store.dispatch("deleteEmployeeGroup", item).then(() => {
        this.reloadDataFunc();
        this.deleteDialog.open = false;
      });
    },
    reloadDataFunc() {
      this.$emit("reloadData");
    },
  },
};
</script>
